import React, { createContext, useEffect } from 'react'

import { themeAwardWidgetDecorator } from '../utils'
import { BOWTIE_BARRIER_SETTINGS } from '../utils/constants'
import { BowtieBarrierSettings } from './BowtieBarrierSettings'

interface ILivePageProps {
    extra: {
        hideHeader: boolean
        hideFooter: boolean
    }
    id: IQueryParamsList | IQueryParamsEdit
    urlParams: (string | Record<string, string | number>)[]
}

export type IQueryParamsTabs =
    | 'barrierCategories'
    | 'semiQualitativeNormalization'
    | 'alarpLevels'
    | 'barrierStatus'
    | 'operations'

export interface IQueryParamsList {
    type: 'list'
    tab?: IQueryParamsTabs
    perPage?: number
    page?: number
    orderBy?: string
    direction?: 'ASC' | 'DESC'
    filterBy?: number
    keyword?: string
    [x: string]: string | number
}

export interface IQueryParamsEdit {
    type: 'edit'
    tab?: IQueryParamsTabs
    id?: number
    aux?: IQueryParamsTabs
    auxId?: number
}

export interface IBowtieBarrierSettingsRouteContext<P extends IQueryParamsList | IQueryParamsEdit> {
    params: P
    setParams: (newParams: IQueryParamsList | IQueryParamsEdit) => void
}

const defaultParams: IQueryParamsList | IQueryParamsEdit = {
    type: 'list',
    tab: 'barrierStatus',
    page: 1,
    perPage: 50,
    direction: 'ASC',
    orderBy: 'ID'
}

function toQueryString(obj: IQueryParamsList | IQueryParamsEdit): string {
    return Object.keys(obj)
        .filter(key => typeof obj[key] === 'string' || typeof obj[key] === 'number' || typeof obj[key] === 'boolean')
        .map(key => (obj[key] !== undefined && obj[key] !== null ? `${key}=${obj[key]}` : undefined))
        .filter(e => e)
        .join('&')
}

export function setParams(params: IQueryParamsList | IQueryParamsEdit): void {
    window.location.href = `/#/config/${BOWTIE_BARRIER_SETTINGS}?${toQueryString(params)}`
}

export const BowtieBarrierSettingsRouteContext = createContext({
    params: defaultParams,
    setParams
} as IBowtieBarrierSettingsRouteContext<any>) // eslint-disable-line prettier/prettier, @typescript-eslint/no-explicit-any

const BowtieBarrierSettingsWrapper: React.FC<ILivePageProps> = ({ id: params }) => {
    useEffect(() => {
        if (!params || !params.type || !params.tab || (params.type === 'edit' && !params.id)) {
            setParams({ ...defaultParams, tab: params?.tab ?? defaultParams.tab })
        } else {
            if (params.type === 'list') {
                setParams({ ...defaultParams, ...params })
            }
        }
    }, [params])

    return (
        <BowtieBarrierSettingsRouteContext.Provider value={{ params: params ?? defaultParams, setParams }}>
            <BowtieBarrierSettings />
        </BowtieBarrierSettingsRouteContext.Provider>
    )
}

export default themeAwardWidgetDecorator(BowtieBarrierSettingsWrapper, ':root')
